import React, { memo } from "react";
import { useHistory } from "react-router-dom";
import PuiTypography from "../../../components/elements/PuiTypography";
import AddTimeline from "./AddTimeline";
import styles from "./TimelineTopMenuArea.module.css";
interface TimelineMenuAreaProps {
    menuType: string;
}

function TimelineTopMenuArea({ menuType }: TimelineMenuAreaProps) {
    const history = useHistory();
    const menuList = [
        {
            name: "プロジェクト",
            path: "/studio/homepage",
        },
        {
            name: "テンプレート",
            path: "/studio/template",
        },
        {
            name: "メディア",
            path: "/studio/directory",
        },
    ];

    const changeType = (path: string) => {
        history.push(path);
    };

    return (
        <div className={styles.leftArea}>
            {/* タイムラインを作成 */}
            <AddTimeline />
            {menuList.map((menu, index) => (
                <div
                    className={styles.navBtn}
                    onClick={() => changeType(menu.path)}
                    style={{
                        backgroundColor: menuType === menu.name ? "#ffffff1a" : "#202327",
                    }}
                    key={index}
                >
                    <div style={{ marginLeft: "36px" }}>
                        <PuiTypography>{menu.name}</PuiTypography>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default memo(TimelineTopMenuArea);
